/**
 * Product gallery: scroll to the featured media by media id on variant change.
 *
 * Impact's product-gallery uses featured_media.position - 1 as a cell index.
 * Media positions can have gaps when images are deleted, so that math skips the
 * wrong slide. Keep theme.js untouched; correct selection here instead.
 */
(function () {
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    const previousVariant = event.detail?.previousVariant;
    const featuredMedia = variant?.featured_media;

    if (!featuredMedia) return;
    if (previousVariant?.featured_media?.id === featuredMedia.id) return;

    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const formId = form.getAttribute('id');
    if (!formId) return;

    const gallery = document.querySelector(`product-gallery[form="${formId}"]`);
    if (!gallery?.carousel) return;

    const cell = gallery.querySelector(`[data-media-id="${featuredMedia.id}"]`);
    if (!cell) return;

    // Run after Impact's product-gallery variant:change handler.
    requestAnimationFrame(() => {
      if (gallery.carousel.isScrollable) {
        const visibleIndex = gallery.carousel.cells.indexOf(cell);
        if (visibleIndex >= 0) {
          gallery.carousel.select(visibleIndex, { instant: true });
        }
      } else {
        cell.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
  });
})();
